import './styles.scss'
import * as React from 'react'
import { Modal } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import { getStaticImage } from 'utils/statics'
import { Button } from 'components/Form'
import { lang } from 'utils/helpers'

const ModalAlert = (props) => {
  const {
    isOpen, toggle = null, header, text1, text2,
    errorMessage, className = 'modal-content-alert', event = null
  } = props

  return (
    <Modal
      id='modal-content-alert'
      centered
      isOpen={isOpen}
      toggle={toggle}
      className={className}
      contentClassName='modal-content-remove'
    >
      <div className='modal-wrapper-header'>
        <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close' onClick={toggle}/>
      </div>
      <img className='icon-alert' src='img/icons/icon-warning-yellow.svg' alt='alert' />
      {
        header
          ? <h1 dangerouslySetInnerHTML={{ __html: header }} />
          : null
      }
      {
        text1
          ? <h2 dangerouslySetInnerHTML={{ __html: text1 }} />
          : null
      }
      {
        text2
          ? <legend dangerouslySetInnerHTML={{ __html: text2 }} />
          : null
      }

      {errorMessage && <p className='error-message' dangerouslySetInnerHTML={{ __html: I18n.t(errorMessage) }}></p>}

      <div className='wrapper-buttons'>
        <Button
          secondary
          value={lang('dashboard_accept')}
          onClick={event ? event : toggle}
          className='button-alert'
        />
      </div>
    </Modal>
  )
}

export default ModalAlert
